
import { Behavior, ChartMetadata, ChartPlugin, t } from '@superset-ui/core';
import buildQuery from '../buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import thumbnail from './images/ring-1.png';
import example from './images/ring-2.png';
import { EchartsGaugeChartProps, EchartsGaugeFormData } from './types';
 
export default class EchartsGaugeGaugeChartPlugin extends ChartPlugin<
   EchartsGaugeFormData,
   EchartsGaugeChartProps
 > {
   constructor() {
     super({
       buildQuery,
       controlPanel,
       loadChart: () => import('./EchartsGauge'),
       metadata: new ChartMetadata({
         behaviors: [Behavior.INTERACTIVE_CHART],
         category: t('KPI'),
         credits: ['https://echarts.apache.org'],
         description:
           t(
            'Uses a gauge to showcase progress of a metric towards a target. The position of the dial represents the progress and the terminal value in the gauge represents the target value.',
           ),
         exampleGallery: [
           { url: thumbnail },
           { url: example },
         ],
         name: t('Ring Gauge'),
         tags: [
          t('Multi-Variables'),
          t('Business'),
          t('Comparison'),
          t('ECharts'),
          t('Report'),
         ],
         thumbnail,
       }),
       transformProps,
     });
   }
}
 